import React, { useState } from 'react';
import ClassAuditRow from './ClassAuditRow';

// Compact, accessible Class Audit grid. One row per class (grain = team_dim_id). Single-row
// expansion (accordion). All status derivation is delegated to getClassStatus() inside the row.
// Semantic <table> with column headers; expansion is a keyboard-operable <button> per row.
export default function ClassAuditList({ rows, levels, onRowUpdate }) {
  const [expandedKey, setExpandedKey] = useState(null);

  const toggle = (key) => setExpandedKey((cur) => (cur === key ? null : key));

  const rowEls = rows.map((row) => (
    <ClassAuditRow
      key={row.team_dim_id}
      row={row}
      levels={levels}
      onRowUpdate={onRowUpdate}
      isExpanded={expandedKey === row.team_dim_id}
      onToggle={() => toggle(row.team_dim_id)}
      // The rows currently in view, so the expanded panel can report a LOWER-BOUND recurrence count
      // for its class. Passed as the array (not a precomputed per-row count) because only ONE row is
      // expanded at a time -- counting eagerly for every row would be O(n^2) over a 5,000-row cap.
      viewRows={rows}
    />
  ));

  // Column order follows the Season Manager identity hierarchy (Franchise -> Facility -> item being
  // audited), matching Season Audit: Franchise and Facility identify the row first, then the class
  // name, then the audited attributes (Canonical level, Instructor), with Status pushed to the far
  // right as in Season Audit.
  //
  // Responsive prep: the grid is wrapped in a horizontal-scroll container and the table carries a
  // min-width, so on narrow screens it scrolls instead of crushing the Status chip or overlapping
  // text (the overflow problem we have in Season Audit). Per-column min-widths keep every column
  // legible; Class name is the widest and is allowed to flex/wrap. The Instructor column is present
  // now as a placeholder to validate the final layout; the auditing feature is built later.
  return (
    <div className="table-responsive">
      <table className="table table-sm align-middle" style={{ minWidth: 940 }}>
        <thead>
          <tr>
            <th scope="col" aria-label="Expand" style={{ width: 40 }}></th>
            <th scope="col" className="text-start" style={{ minWidth: 150 }}>Franchise</th>
            <th scope="col" className="text-start" style={{ minWidth: 150 }}>Facility</th>
            <th scope="col" className="text-start" style={{ minWidth: 200 }}>Class name</th>
            <th scope="col" className="text-start" style={{ minWidth: 120 }}>Canonical level</th>
            <th scope="col" className="text-start" style={{ minWidth: 150 }}>Instructor</th>
            <th scope="col" className="text-start" style={{ minWidth: 130, whiteSpace: 'nowrap' }}>Status</th>
          </tr>
        </thead>
        <tbody>
          {rowEls}
        </tbody>
      </table>
    </div>
  );
}
